var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommPendingApproval(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14712_9128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5015 23.8335C25.9005 23.8335 22.168 27.564 22.168 32.1665C22.168 36.768 25.9005 40.5 30.5015 40.5C35.1024 40.5 38.835 36.768 38.835 32.1665C38.835 27.564 35.1024 23.8335 30.5015 23.8335ZM35.5015 33.4165H29.2515V27.1665H31.7515V30.9165H35.5015V33.4165Z",
    fill: "#73007D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.835 0.5H5.50146C3.66895 0.5 2.16797 2.00049 2.16797 3.8335V33.8335C2.16797 35.666 3.66895 37.1665 5.50146 37.1665H18.835V32.1665C18.835 25.7345 24.0694 20.5 30.5015 20.5H32.168V3.8335C32.168 2.00049 30.6675 0.5 28.835 0.5ZM7.16797 5.5H23.835V8.8335H7.16797V5.5ZM13.835 28.8335H7.16797V25.5H13.835V28.8335ZM17.168 22.1665H7.16797V18.8335H17.168V22.1665ZM27.168 15.5H7.16797V12.1665H27.168V15.5Z",
    fill: "#73007D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14712_9128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommPendingApproval);
export default __webpack_public_path__ + "static/media/comm_pending_approval.ed48a08fa6d72b536fe7dbb86fa8ff02.svg";
export { ForwardRef as ReactComponent };